/** Kleine UI-Helfer ohne Framework. */
import { WEEKDAYS_SHORT, formatDateDe, weekday } from '../shared/time.js';

export function esc(v: unknown): string {
  return String(v ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]!);
}

export function $(sel: string, root: ParentNode = document): HTMLElement {
  const el = root.querySelector(sel);
  if (!el) throw new Error(`Element fehlt: ${sel}`);
  return el as HTMLElement;
}

export function $$(sel: string, root: ParentNode = document): HTMLElement[] {
  return [...root.querySelectorAll(sel)] as HTMLElement[];
}

let toastTimer: number | undefined;
export function toast(msg: string, kind: 'ok' | 'warn' | 'error' = 'ok'): void {
  const el = $('#toast');
  el.textContent = msg;
  el.className = `toast show ${kind}`;
  window.clearTimeout(toastTimer);
  toastTimer = window.setTimeout(() => (el.className = 'toast'), kind === 'ok' ? 2500 : 6000);
}

/** '2026-09-25' → 'Fr 25.09.' */
export function dayLabel(date: string): string {
  return `${WEEKDAYS_SHORT[weekday(date)]} ${formatDateDe(date).slice(0, 6)}`;
}

export function formValues(form: HTMLFormElement): Record<string, string> {
  const out: Record<string, string> = {};
  new FormData(form).forEach((v, k) => (out[k] = String(v)));
  return out;
}

export function errorText(err: unknown): string {
  if (err instanceof Error) {
    if (err.name === 'NetworkError') return 'Keine Verbindung – bitte später erneut versuchen.';
    return err.message;
  }
  return String(err);
}

export function options(list: string[], selected: string): string {
  const all = selected && !list.includes(selected) ? [selected, ...list] : list;
  return all.map((a) => `<option ${a === selected ? 'selected' : ''}>${esc(a)}</option>`).join('');
}
